(function () {
  var tileClassName = '.product-grid-item';
  var $WishlistButtons;
  var $WishlistTile;
  var $WishlistItemCount;
  var numProductTiles;
  var Wishlist = localStorage.getItem('user_Wishlist') || [];
  if (Wishlist.length > 0) {
    Wishlist = [...new Set(JSON.parse(localStorage.getItem('user_Wishlist')))].filter(item => item != null && item != '');
  }

  /*
   *　対象にアクティブかどうかのクラスを付ける
   */
  var activeToggleClass = function (self) {
    if (self.classList.contains('is-active')) {
      self.classList.remove('is-active');
    } else {
      self.classList.add('is-active');
    }
  };

  /*
   * 選択したアイテムを localStorage のユーザーのお気に入り配列に追加/削除します
   * お気に入りボタンの'.is-active'クラスの有無で判定
   */
  var updateWishlist = function (self) {
    var productHandle = self.getAttribute('data-product-handle');
    var isRemove = self.classList.contains('is-active');
    if (isRemove) {
      var removeIndex = Wishlist.indexOf(productHandle);
      Wishlist.splice(removeIndex, 1);
      localStorage.setItem('user_Wishlist', JSON.stringify(Wishlist));
      if (window.location.href.indexOf('pages/wishlist') > -1) {
        self.closest(tileClassName).remove();
        numProductTiles--;
        if(numProductTiles == 0){
          document.querySelector('.wishlist-grid--empty-list').classList.add('is-visible');
          document.querySelector('.wishlist-container').classList.remove('is-visible')
        }
      }
    } else {
      Wishlist.push(productHandle);
      localStorage.setItem('user_Wishlist', JSON.stringify(Wishlist));
    }
  };

  /*
   * ページ読込時にお気に入り追加済みの商品のボタンに対して'is-active'クラスを付ける
   */
  var activateItemsInWishlist = function () {
    if($WishlistButtons){
      for (var i = 0; i < $WishlistButtons.length; i++) {
        var productHandle = $WishlistButtons[i].getAttribute('data-product-handle');
        if (Wishlist.indexOf(productHandle) > -1) {
          $WishlistButtons[i].classList.add('is-active');
        }
      }
    }
  };

  /*
   * 商品リストをループしてお気に入りに'data-product-handle'が無い場合、自身を削除
   */
  var displayOnlyWishlistItems = function () {
    for (var i = 0; i < $WishlistTile.length; i++) {
      var productHandle = $WishlistTile[i].getAttribute('data-product-handle');
      if (Wishlist.indexOf(productHandle) === -1) {
        $WishlistTile[i].remove();
        numProductTiles--;
      }
    }

    if (numProductTiles == 0) {
      document.querySelector('.wishlist-grid--empty-list').classList.add('is-visible');
      document.querySelector('.wishlist-container').classList.remove('is-visible')
    } else {
      document.querySelector('.wishlist-grid--empty-list').classList.remove('is-visible');
    }
  };

  /*
   * お気に入りリストページで商品ハンドルが登録されていないもの削除する
   * ※登録されている全商品一覧から不要なもの削除していく仕組み
   */
  var loadWishlist = function () {
    displayOnlyWishlistItems();
    document.querySelector('.wishlist-loader').style.display = 'none';
    if (numProductTiles == 0) {
      document.querySelector('.wishlist-container').classList.remove('is-visible');
      document.querySelector('.wishlist-grid--empty-list').classList.add('is-visible');
    } else {
      document.querySelector('.wishlist-container').classList.add('is-visible');
      document.querySelector('.wishlist-grid--empty-list').classList.remove('is-visible');
    }
  };

  var updateWishlistItemCount = function () {
    if ($WishlistItemCount && Wishlist) {
      $WishlistItemCount.textContent = Wishlist.length;
    }
  };

  var bindUIActions = function () {
    $WishlistButtons.forEach(function(element) {
      element.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        updateWishlist(this);
        activeToggleClass(this);
      });
    });
  };

  var init = function () {
    $WishlistButtons = document.querySelectorAll('.wishlist-btn');
    $WishlistTile = document.querySelectorAll(tileClassName);
    $WishlistItemCount = document.querySelector('.wishlist-item-count');
    numProductTiles = $WishlistTile.length;
    bindUIActions();
    activateItemsInWishlist();
    updateWishlistItemCount();
    if (window.location.href.indexOf('pages/wishlist') > -1) {
      loadWishlist();
    }
  };
  window.addEventListener('products:load', function() {
    init();
  });
})();
